const authRoutes = {
  signIn: '/sign-in',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
};

export default authRoutes;

/**
 * Routes that only make sense signed out. The header renders its signed-out
 * variant on these regardless of auth state — otherwise it flips the moment the
 * store updates, which is a frame or two before the navigation lands, and the
 * signed-in header appears on the sign-in page mid-transition.
 */
export const SIGNED_OUT_ROUTE_PREFIXES = ['/sign-in', '/login', '/forgot-password', '/password-setup', '/password-change'];
